export default __webpack_public_path__ + "static/media/default-church-logo.7b023194.png";